
export function getToday () {
  return new Date()
}

export function getThisMonth () {
  let today = getToday()
  return new Date(today.getFullYear(), today.getMonth())
}

export function yyyyMmJpDateFormat (date) {
  return date.getFullYear() + '年' + (date.getMonth() + 1) + '月'
}

export function yyyyMmDdStrToDate (yyyymmdd) {
  return new Date(yyyymmdd.substr(0, 4), Number(yyyymmdd.substr(4, 2)) - 1, Number(yyyymmdd.substr(6, 2)))
}

export function dateToyyyyMmStr (date) {
  return date.getFullYear() + ('0' + (date.getMonth() + 1)).slice(-2)
}

export function dateToyyyyMmDdStr (date) {
  return date.getFullYear() + ('0' + (date.getMonth() + 1)).slice(-2) + ('0' + date.getDate()).slice(-2)
}

export function dateToyyyyMmDdHHmmssStr (date = new Date()) {
  return date.getFullYear() + '/' + ('0' + (date.getMonth() + 1)).slice(-2) + '/' + ('0' + date.getDate()).slice(-2) + ' ' +
    ('0' + date.getHours()).slice(-2) + ':' + ('0' + date.getMinutes()).slice(-2) + ':' + ('0' + date.getSeconds()).slice(-2)
}

export function calcDateYear (year) {
  let date = new Date()
  date.setFullYear(date.getFullYear() + year)
  return dateToyyyyMmStr(date) + '01'
}

export function calcDateMonth (month) {
  let date = new Date()
  date.setMonth(date.getMonth() + month)
  return dateToyyyyMmStr(date) + '01'
}



// WEBPACK FOOTER //
// ./src/utils/DateHelper.js